"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _core = require("core.ui-module_site-components");
var _ApplicationContext = require("../../api/ApplicationContext");
var _UsernamePasswordStepResponse = _interopRequireDefault(require("../../api/auth/UsernamePasswordStepResponse"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class UsernamePasswordStep extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      username: '',
      password: undefined,
      errorMessage: ''
    };
  }
  submit(e) {
    e.preventDefault();
    this.setState({
      errorMessage: '',
      isLoading: true
    });
    const step = new _UsernamePasswordStepResponse.default();
    step.username = this.state.username;
    step.password = btoa(this.state.password);
    this.props.listener(this, step);
  }
  change(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }
  render() {
    const {
      errorMessage,
      username,
      password,
      isLoading
    } = this.state;
    const {
      isFromMarketingRep,
      loginAuthenticationHelp,
      site
    } = this.props;
    const disabled = username.length === 0 || !password || password.length === 0;
    let authenticationHelpContent = '';
    if (window.location.pathname !== '/account_support/login.html' && !isFromMarketingRep) {
      if (loginAuthenticationHelp) {
        if (typeof loginAuthenticationHelp === 'string') {
          authenticationHelpContent = /*#__PURE__*/_react.default.createElement("span", {
            className: "navigate-link-text",
            dangerouslySetInnerHTML: {
              __html: _dompurify.default.sanitize(loginAuthenticationHelp)
            }
          });
        } else {
          authenticationHelpContent = loginAuthenticationHelp;
        }
      } else if (_ApplicationContext.ApplicationContext.isWebUserReset()) {
        authenticationHelpContent = /*#__PURE__*/_react.default.createElement("div", {
          className: "control"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "navigate-link-wrapper"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "material-icons has-text-link"
        }, "navigate_next"), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
          to: "/forgot.html",
          className: "step-navigation-link"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "navigate-link-text",
          dangerouslySetInnerHTML: {
            __html: _dompurify.default.sanitize(site.loginGreetingForgotLoginLabel && site.loginGreetingForgotLoginLabel.length > 0 ? site.loginGreetingForgotLoginLabel : 'Need help with your username or password')
          }
        }))));
      }
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "workflow-step--username-password"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: `lds-spinner-overlay ${isLoading && 'is-active'}`
    }, isLoading && /*#__PURE__*/_react.default.createElement(_core.Spinner, null)), /*#__PURE__*/_react.default.createElement(_core.OkModal, {
      header: "Authentication Failed",
      message: errorMessage,
      display: errorMessage !== '',
      key: errorMessage
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "login-box content"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title",
      dangerouslySetInnerHTML: {
        __html: _ApplicationContext.ApplicationContext.getLoginGreetingTitle() ? _dompurify.default.sanitize(_ApplicationContext.ApplicationContext.getLoginGreetingTitle()) : 'Welcome back'
      }
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "subtitle"
    }, isFromMarketingRep ? 'Log in to the MissionSquare Retirement Consultant Portal for Sales' : _ApplicationContext.ApplicationContext.getLoginGreetingSubTitle() || `Log in to the ${_ApplicationContext.ApplicationContext.getSiteName()}`), /*#__PURE__*/_react.default.createElement("div", {
      className: "content"
    }, /*#__PURE__*/_react.default.createElement("form", {
      id: "loginForm",
      method: "post",
      onSubmit: e => this.submit(e)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "field field-userid"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "userId",
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "login-box-userid label-text"
    }, "User ID"), /*#__PURE__*/_react.default.createElement("div", {
      className: "control has-icons-left"
    }, /*#__PURE__*/_react.default.createElement("input", {
      id: "userId",
      type: "text",
      name: "username",
      size: "50",
      autoComplete: "username",
      placeholder: "Username",
      className: "input",
      value: this.state.username,
      autoFocus: true,
      onChange: e => this.change(e)
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon is-small is-left"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons"
    }, "person"))))), /*#__PURE__*/_react.default.createElement("div", {
      className: "field field-pwd"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "pwd",
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "login-box-pwd label-text"
    }, "Password"), /*#__PURE__*/_react.default.createElement("div", {
      className: "control has-icons-left"
    }, /*#__PURE__*/_react.default.createElement("input", {
      id: "pwd",
      type: "password",
      name: "password",
      size: "50",
      autoComplete: "current-password",
      placeholder: "Password",
      value: this.state.password ? this.state.password : '',
      className: "input",
      onChange: e => this.change(e)
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon is-small is-left"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons"
    }, "lock"))))), /*#__PURE__*/_react.default.createElement("div", {
      className: "field field-submit-button"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "control"
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: "is-primary",
      disabled: disabled
    }, "Log In"))), /*#__PURE__*/_react.default.createElement("div", {
      className: "field field-navigate-link"
    }, authenticationHelpContent)))));
  }
}
UsernamePasswordStep.propTypes = {
  listener: _propTypes.default.func.isRequired,
  isFromMarketingRep: _propTypes.default.bool,
  site: _propTypes.default.shape({
    loginGreetingForgotLoginLabel: _propTypes.default.string
  }),
  loginAuthenticationHelp: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object])
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(UsernamePasswordStep);
//# sourceMappingURL=UsernamePasswordStep.js.map